import { Box, createTheme, responsiveFontSizes, ThemeProvider, Typography } from "@material-ui/core";
import React from "react";
import { TF } from "../../components/typography/TF";

let theme = createTheme({});
theme = responsiveFontSizes(theme);

export const TestPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box>
          <Typography variant="h1">H1 Lorem Ipsum</Typography>
          <Typography variant="h2">H2 Lorem Ipsum</Typography>
          <Typography variant="h3">H3 Lorem Ipsum</Typography>
          <Typography variant="h4">H4 Lorem Ipsum</Typography>
          <Typography variant="h5">H5 Lorem Ipsum</Typography>
          <Typography variant="h6">H6 Lorem Ipsum</Typography>
          <Typography variant="body1">Body1 Lorem Ipsum</Typography>
          <br />
          <Typography variant="body2">Body2 Lorem Ipsum</Typography>
          <br />
          <Typography variant="subtitle1">Subtitle1 Lorem Ipsum</Typography>
          <br />
          <Typography variant="subtitle2">Subtitle2 Lorem Ipsum</Typography>
          <br />
          <Typography variant="caption">caption Lorem Ipsum</Typography>
          <br />
          <Typography variant="button">button Lorem Ipsum</Typography>
          <br />
          <Typography variant="overline">overline Lorem Ipsum</Typography>
          <br />
          <Typography variant="srOnly">srOnly Lorem Ipsum</Typography>
          <br />
          <Typography variant="inherit">Inherit Lorem Ipsum</Typography>
          <br />
          <TF variant="h1" color="secondary">
            TF H1 secondary Lorem Ipsum
          </TF>
          <br />
          <TF variant="body2" color="#979797">
            TF Body2 #979797 Lorem Ipsum
          </TF>
          <br />
          <TF variant="h1" fontSize="13px" bold>
            TF H1 13px Lorem Ipsum
          </TF>
          <br />
          <TF color="storeRed">TF #FF0A0A Lorem Ipsum</TF>
          <br />
          <TF color="storeGrey">TF storeGrey Lorem Ipsum</TF>
          <br />
          <TF color="storeGrey" format="price">
            123
          </TF>
          <br />
        </Box>
      </Box>
    </ThemeProvider>
  );
};
